"use client";

import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";
import { AboutPage } from "~/modules/legal/pages/about";

import type { JSX } from "react";

// // // //

export function AboutView(): JSX.Element {
    return (
        <PageTrack route={Routes.about}>
            <UserFetcher>
                {({ user }) => <Navbar route={Routes.about} user={user} />}
            </UserFetcher>
            <SidebarLayout pathname={Routes.about}>
                <PageWrapper>
                    <AboutPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
